<div class="help-tooltip active"
     [class.products]="isForProducts">
  <div class="close-btn" (click)="toggledChange.emit(false)"></div>
  <p>
    {{text}}
  </p>
</div>
